import React from 'react';
import Header from '../Header/Header';
import VerificationBanner from '../VerificationBanner/VerificationBanner';
import Footer from '../Footer/Footer';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
  return (
    <div className={styles.container} style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Header />
      <VerificationBanner />
      <div className={styles.contentWrapper} style={{
        display: 'flex',
        flex: 1,
        padding: '1rem',
        width: '100%',
        maxWidth: '1600px',
        margin: '0 auto',
        background: '#1e293b',
        borderRadius: '12px',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.3)',
        overflow: 'hidden'
      }}>
        <Sidebar />
        <div style={{
          width: '1px',
          background: 'linear-gradient(to bottom, transparent, #475569 20%, #475569 80%, transparent)',
          margin: '0 1rem'
        }} />
        <main className={styles.main} style={{
          flex: 1,
          padding: '0'
        }}>
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
